import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';

// 🌐SSR安全化: 言語自動判定(navigator/localStorage前提)はブラウザでだけ有効化。
// サーバー(プリレンダ)では既定言語で描画する。
const inst = i18n.use(initReactI18next);
if (typeof window !== 'undefined') inst.use(LanguageDetector);
inst
  .init({
    lng: 'en',
    fallbackLng: 'en',
    debug: false,
    resources: messages,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;